export default __webpack_public_path__ + "static/media/crew-training-milestone-tracker-header.7d9149c1.png";